$(document).ready(function () {
  showLoader(); 
  $('.js-compare-btn').prop('disabled', true);
  $('.js-reset-btn').prop('disabled', true);
  
  /* ========= INIT: PAGE SIZE ========= */
  const PAGE_SIZE = 100;

  /* ========= INIT: ALL SHAPES ========= */
  const FULL_SHAPE_LIST = [
    "Oval", "Round", "Emerald", "Pear",
    "Marquise", "Radiant", "Cushion",
    "Antique-Style Cushion", "Antique-Style Round"
  ];

  /* ========= INIT: SHAPE VARIANTS (UI shape → API shape) ========= */
  const SHAPE_VARIANT_MAP = {
    "Emerald (North/South)": "Emerald",
    "Emerald (East/West)": "Emerald"
  };

  const _allowedShapesParam = new URLSearchParams(window.location.search).get('allowed_shapes');
  const ALL_SHAPES = (_allowedShapesParam && _allowedShapesParam.trim())
    ? _allowedShapesParam.split(',')
        .map(s => s.trim())
        .filter(s => FULL_SHAPE_LIST.includes(s) || SHAPE_VARIANT_MAP.hasOwnProperty(s))
    : FULL_SHAPE_LIST;

  /* ========= INIT: PRICE RANGES ========= */
  var minPriceLabGrown = 2000;
  var maxPriceLabGrown = 50000;
  var minPriceNatural  = 2000;
  var maxPriceNatural  = 150000;

  /* ========= INIT: CARAT WEIGHT RANGES ========= */
  var minCaratLabGrown = 2.00;
  var maxCaratLabGrown = 5.00;
  var minCaratNatural  = 1.00;
  var maxCaratNatural  = 7.10;

  /* ========= INIT: RATIO RANGES ========= */
  var minRatioDefault = 0.95;
  var maxRatioDefault = 2.50;

  /* ========= INIT: COLOR OPTIONS ========= */
  const COLOR_SCALE = ["D","E","F","G","H","I","J"];

  /* ========= INIT: CLARITY OPTIONS ========= */
  const CLARITY_SCALE = ["IF","VVS1","VVS2","VS1","VS2","SI1","SI2"];
  
  /* ========= INIT: FLUORESCENCE STEPS ========= */
  let currentFluorStartStep = 1;
  let currentFluorEndStep = 4;

  /* ========= USER INTERACTION FLAGS ========= */
  let isPriceInteracted   = false;
  let isCaratInteracted   = false;
  let isRatioInteracted   = false;
  let isColorInteracted   = false;
  let isClarityInteracted = false;
  let isFluorescenceInteracted = false;

  /* ========= SORTING FLAGS ========= */
  let currentSortBy = null;
  let currentSortDirection = null;

  /* ========= SORT ARROW SVGs ========= */
  const arrowUp = `<svg class="sort-arrow" width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg">
    <line x1="13.2929" y1="7" x2="7" y2="0.707107" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
    <line x1="7" y1="0.707107" x2="0.707107" y2="7" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>`;

  const arrowDown = `<svg class="sort-arrow" width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg">
    <line x1="0.707107" y1="1" x2="7" y2="7.29289" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
    <line x1="7" y1="7.29289" x2="13.2929" y2="1" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>`;

  /* ========= INIT: COMPARE FROM URL ========= */
  const urlParams = new URLSearchParams(window.location.search);
  const cNumParam = urlParams.get('c_num');
  let selectedCompareDiamonds = cNumParam ? cNumParam.split(',').filter(Boolean) : [];

  // Sync compare button text on load from URL
  const initialCount = selectedCompareDiamonds.length;
  $('.js-compare-btn').text(`COMPARE DIAMONDS (${initialCount}/3)`).prop('disabled', initialCount === 0);
  $('.js-reset-btn').prop('disabled', initialCount === 0);

  let {
    page: currentPage,
    shapes,
    cert,
    lg,
    price_min,
    price_max,
    carat_min,
    carat_max,
    color_from,
    color_to,
    clarity_from,
    clarity_to,
    ratio_min,
    ratio_max,
    fluor_start,
    fluor_end,
    sort_by,
    sort_direction
  } = getParams();

  /* ========= CHECK FLUORESCENCE INTERACTION ========= */
  if (Number.isInteger(fluor_start) && Number.isInteger(fluor_end)) {
    currentFluorStartStep = fluor_start;
    currentFluorEndStep = fluor_end;
    isFluorescenceInteracted = true;
  }

  /* ========= SELECTED FILTERS ========= */
  let filters = {
    shapes: shapes === 'all' ? [] : (shapes.length ? shapes : ALL_SHAPES)
  };

  let selectedCert = cert;
  let openRow = null;
  let isLabGrown = lg || false;

  /* ========= DISABLE ANTIQUE STYLE DIAMONDS FOR LAB GROWN ========= */
  handleAntiqueShapesState();

  /* ========= HIDE SHAPE CHECKBOXES NOT AVAILABLE ON PRODUCT ========= */
  function syncShapeFilterToProduct() {
    $('.shape-list label').each(function () {
      const val = $(this).find('input').val();
      if (!ALL_SHAPES.includes(val)) {
        $(this).hide();
      }
    });
  }
  syncShapeFilterToProduct();

  /* ========= PRICE STATE ========= */
  let currentPriceMin = price_min || (isLabGrown ? minPriceLabGrown : minPriceNatural);
  let currentPriceMax = price_max || (isLabGrown ? maxPriceLabGrown : maxPriceNatural);

   /* ========= CARAT WEIGHT STATE ========= */
  let currentCaratMin = carat_min || (isLabGrown ? minCaratLabGrown : minCaratNatural);
  let currentCaratMax = carat_max || (isLabGrown ? maxCaratLabGrown : maxCaratNatural);

  /* ========= COLOR STATE ========= */
  let currentColorFrom = color_from || "D";
  let currentColorTo = color_to || "J";

  /* ========= CLARITY STATE ========= */
  let currentClarityFrom = clarity_from || "IF";
  let currentClarityTo = clarity_to || "SI2";

  /* ========= RATIO STATE ========= */
  let currentRatioMin = ratio_min || minRatioDefault;
  let currentRatioMax = ratio_max || maxRatioDefault;

  /* ========= MARK FILTERS AS INTERACTED FROM URL ========= */
  if (price_min !== undefined && price_min !== null) {
    isPriceInteracted = true;
  }
  if (carat_min !== undefined && carat_min !== null) {
    isCaratInteracted = true;
  }
  if (ratio_min !== undefined && ratio_min !== null) {
    isRatioInteracted = true;
  }
  if (color_from && color_to) {
    isColorInteracted = true;
  }
  if (clarity_from !== null && clarity_to !== null) {
    isClarityInteracted = true;
  }

  /* ========= SYNC TOGGLE UI ========= */
  if (isLabGrown) {
    $('.diamond-type-btn').removeClass('active');
    $('.diamond-type-btn[data-type="lab"]').addClass('active');
  }

  /* ========= SYNC SHAPE UI ========= */
  if (shapes !== 'all') {
    filters.shapes.forEach(shape => {
      $(`.shape-list input[value="${shape}"]`).prop('checked', true);
    });
  }

  /* ========= GENERATE DYNAMIC FLUORESCENCE PAYLOAD ========= */
  function getFluorescencePayloadBySteps(startStep, endStep) {
    if (startStep > endStep) {
      [startStep, endStep] = [endStep, startStep];
    }
    const map = {
      "1-1": { fluor_intensity: ["Medium", "Medium"], fluor_intensity_min: "$1", fluor_intensity_max: "$1" },
      "1-2": { fluor_intensity: ["Medium", "Medium"], fluor_intensity_min: "$1", fluor_intensity_max: "$2" },
      "1-3": { fluor_intensity: ["Medium", "Faint"],  fluor_intensity_min: "$1", fluor_intensity_max: "$3" },
      "1-4": { fluor_intensity: "", fluor_intensity_min: "", fluor_intensity_max: "" },
      "2-2": { fluor_intensity: ["Faint", "Medium"], fluor_intensity_min: "$2", fluor_intensity_max: "$2" },
      "2-3": { fluor_intensity: ["Faint", "Faint"],  fluor_intensity_min: "$2", fluor_intensity_max: "$3" },
      "2-4": { fluor_intensity: ["Faint", "None"],   fluor_intensity_min: "$2", fluor_intensity_max: "$4" },
      "3-3": { fluor_intensity: ["None", "Faint"], fluor_intensity_min: "$3", fluor_intensity_max: "$3" },
      "3-4": { fluor_intensity: ["None", "None"],  fluor_intensity_min: "$3", fluor_intensity_max: "$4" },
      "4-4": { fluor_intensity: ["None", "None"],  fluor_intensity_min: "$4", fluor_intensity_max: "$4" }
    };
    return map[`${startStep}-${endStep}`] || {
      fluor_intensity: "",
      fluor_intensity_min: "",
      fluor_intensity_max: ""
    };
  }

  /* ========= URL HELPERS ========= */
  function getParams() {
    const params = new URLSearchParams(window.location.search);
    return {
      page: parseInt(params.get('page')) || 1,
      shapes: params.get('shapes') === 'all'
        ? 'all'
        : (params.get('shapes') ? params.get('shapes').split(',') : []),
      cert: params.get('cert') || null,
      lg: params.get('lg') === 'true',
      price_min: parseInt(params.get('price_min')),
      price_max: parseInt(params.get('price_max')),
      carat_min: parseFloat(params.get('carat_min')),
      carat_max: parseFloat(params.get('carat_max')),
      color_from: params.get('color_from'),
      color_to: params.get('color_to'),
      clarity_from: params.get('clarity_from'),
      clarity_to: params.get('clarity_to'),
      ratio_min: parseFloat(params.get('ratio_min')),
      ratio_max: parseFloat(params.get('ratio_max')),
      fluor_start: parseInt(params.get('fluor_start')),
      fluor_end: parseInt(params.get('fluor_end')),
      sort_by: params.get('sort_by'),
      sort_direction: params.get('sort_direction')
    };
  }

  currentSortBy = sort_by || "Size";
  currentSortDirection = sort_direction || "Asc";

  /* ========= UPDATE: URL PARAMS ========= */
  function updateURL() {
    const url = new URL(window.location);
    url.searchParams.set('page', currentPage);

    if (filters.shapes.length === 0) {
      url.searchParams.set('shapes', 'all');
    } else {
      url.searchParams.set('shapes', filters.shapes.join(','));
    }

    if (selectedCert) {
      url.searchParams.set('cert', selectedCert);
    } else {
      url.searchParams.delete('cert');
    }

    if (isLabGrown) {
      url.searchParams.set('lg', 'true');
    } else {
      url.searchParams.delete('lg');
    }

    url.searchParams.set('price_min', currentPriceMin);
    url.searchParams.set('price_max', currentPriceMax);
    url.searchParams.set('carat_min', currentCaratMin);
    url.searchParams.set('carat_max', currentCaratMax);
    url.searchParams.set('color_from', currentColorFrom);
    url.searchParams.set('color_to', currentColorTo);
    url.searchParams.set('clarity_from', currentClarityFrom);
    url.searchParams.set('clarity_to', currentClarityTo);
    url.searchParams.set('ratio_min', currentRatioMin);
    url.searchParams.set('ratio_max', currentRatioMax);

    if (isFluorescenceInteracted) {
      url.searchParams.set('fluor_start', currentFluorStartStep);
      url.searchParams.set('fluor_end', currentFluorEndStep);
    } else {
      url.searchParams.delete('fluor_start');
      url.searchParams.delete('fluor_end');
    }

    if (currentSortBy && currentSortDirection) {
      url.searchParams.set('sort_by', currentSortBy);
      url.searchParams.set('sort_direction', currentSortDirection);
    } else {
      url.searchParams.delete('sort_by');
      url.searchParams.delete('sort_direction');
    }

    // Preserve Ring_Size if present
    const existingRingSize = new URLSearchParams(window.location.search).get('Ring_Size');
    if (existingRingSize) {
      url.searchParams.set('Ring_Size', existingRingSize);
    }

    // Preserve allowed_shapes if present
    const existingAllowedShapes = new URLSearchParams(window.location.search).get('allowed_shapes');
    if (existingAllowedShapes) {
      url.searchParams.set('allowed_shapes', existingAllowedShapes);
    }

    window.history.pushState({}, '', url);
  }

  /* ========= UPDATE URL WITH COMPARE: SELECTED DIAMONDS ========= */
  function updateCompareInURL() {
    const url = new URL(window.location);
    
    // Preserve Ring_Size
    const existingRingSize = new URLSearchParams(window.location.search).get('Ring_Size');
    if (existingRingSize) {
      url.searchParams.set('Ring_Size', existingRingSize);
    }

    if (selectedCompareDiamonds.length > 0) {
      url.searchParams.set('c_num', selectedCompareDiamonds.join(','));
    } else {
      url.searchParams.delete('c_num');
    }

    // Preserve allowed_shapes if present
    const existingAllowedShapes = new URLSearchParams(window.location.search).get('allowed_shapes');
    if (existingAllowedShapes) {
      url.searchParams.set('allowed_shapes', existingAllowedShapes);
    }

    window.history.pushState({}, '', url);
  }

  /* ========= CLAMP FUNCTION ========= */
  function clamp(val, min, max) {
    return Math.max(min, Math.min(val, max));
  }

  /* ========= MAP DIAMOND FEED ROW ========= */
  function mapRow(d) {
    return {
      shape: d.shape,
      size: d.size,
      color: d.color,
      clarity: d.clarity,
      price: d.marked_up_price,
      raw: d
    };
  }

  /* ========= SORTING MAP ========= */
  const SORT_MAP = {
    shape: "shapes",
    carat: "Size",
    color: "color",
    clarity: "clarity",
    price: "Price"
  };

  function isDefaultRange(currentMin, currentMax, range) {
    return currentMin === range.min && currentMax === range.max;
  }

  /* ========= HANDLING ENABLE/DISABLE STATE FOR ANTIQUE STYLE DIAMONDS ========= */
  function handleAntiqueShapesState() {
    const antiqueSelectors = [
      'input[value="Antique-Style Round"]',
      'input[value="Antique-Style Cushion"]'
    ];
    antiqueSelectors.forEach(selector => {
      const $input = $(`.shape-list ${selector}`);
      const $label = $input.closest('label');
      if (isLabGrown) {
        $input.prop('checked', false);
        $input.prop('disabled', true);
        $label.addClass('rc-diamond-disabled');
      } else {
        $input.prop('disabled', false);
        $label.removeClass('rc-diamond-disabled');
      }
    });
    if (isLabGrown) {
      filters.shapes = filters.shapes.filter(
        s => s !== 'Antique-Style Round' && s !== 'Antique-Style Cushion'
      );
    }
  }

  /* ========= MANAGE DIAMOND SHAPES PAYLOAD FOR LAB GROWN & NATURAL =========*/
  function getSanitizedShapes() {
    const antiqueShapes = ['Antique-Style Round', 'Antique-Style Cushion'];
    let shapesToSend = filters.shapes.length ? [...filters.shapes] : [...ALL_SHAPES];
    // Constrain to product-allowed shapes (variant names still intact here)
    shapesToSend = shapesToSend.filter(s => ALL_SHAPES.includes(s));
    if (isLabGrown) {
      shapesToSend = shapesToSend.filter(s => !antiqueShapes.includes(s));
    }
    // Map UI variant shapes → API base shape, then de-duplicate
    shapesToSend = [...new Set(shapesToSend.map(s => SHAPE_VARIANT_MAP[s] || s))];
    return shapesToSend;
  }

  /* ========= FEED PAGINATION ========= */
  function renderPagination(total, pageSize, currentPage) {
    const totalPages = Math.ceil(total / pageSize);
    let html = '';
    for (let i = 1; i <= totalPages; i++) {
      html += `<button class="rc-bespoke-page-btn ${i === currentPage ? 'active' : ''}" data-page="${i}">${i}</button>`;
    }
    $('#bespokePagination').html(html);
  }

  /* ========= SHOW SELECTED DIAMOND DATA ========= */
  function showDiamondData(d) {
    const diamond = d.raw;
    const certUrl = getCertificateUrl(diamond, isLabGrown);
    const diamond_dimension = (diamond.meas_length && diamond.meas_width && diamond.meas_depth)
          ? `${parseFloat(diamond.meas_length).toFixed(2)}x${parseFloat(diamond.meas_width).toFixed(2)}x${parseFloat(diamond.meas_depth).toFixed(2)}` : '-';
    const selectedDiamond = getSelectedDiamondFromStorage();
    const isSelected = selectedDiamond && selectedDiamond.cert_num == diamond.cert_num;

    /* ========= CHECK COMPARE STATE AT RENDER TIME ========= */
    const isInCompare = selectedCompareDiamonds.includes(String(diamond.cert_num));

    return `
      <div class="accordion-content rc-bespoke-diamond-details">
        <div class="rc-bespoke-diamond-wrapper">
          <div 
            class="rc-bespoke-diamond-image"
            id="panel__inner${diamond.cert_num}"
            data-diamondid="${diamond.diamond_id || ''}"
            data-stockNumber="${diamond.stock_num || ''}"
            data-cert_num="${diamond.cert_num}"
            data-rapnet_account_id="${diamond.rapnet_account_id || ''}"
            videourl="${diamond.video || ''}"
            uniqueid="${diamond.cert_num}"
          >
            <div class="loader__section">
              <div class="loader loader-20">
                <div class="css-diamond"></div>
              </div>
            </div>
          </div>
          <div class="rc-bespoke-diamond-info">
            <p>
              <strong>CERTIFICATE:</strong> 
              <a href="${certUrl}" target="_blank">View <span>Certificate</span></a>
            </p>
            <p>
              <strong>MEASUREMENTS (MM):</strong> 
              ${diamond_dimension || '-'}
            </p>
            <p>
              <strong>POLISH:</strong> 
              ${diamond.polish || '-'}
              <span class="rc-tooltip-wrap">
                <svg class="info__icon" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                  <path d="M9.54922 1.40356C14.051 1.40356 17.7343 5.19317 17.7343 9.82492C17.7343 14.4567 14.051 18.2463 9.54922 18.2463C5.04745 18.2463 1.36417 14.4567 1.36417 9.82492C1.36417 5.19317 5.04745 1.40356 9.54922 1.40356ZM9.54922 0C4.29715 0 0 4.42121 0 9.82492C0 15.2286 4.29715 19.6498 9.54922 19.6498C14.8013 19.6498 19.0984 15.2286 19.0984 9.82492C19.0984 4.35104 14.8013 0 9.54922 0Z" fill="black" />
                  <path d="M8.86531 12.7023C8.86531 12.4918 8.86531 12.3514 8.86531 12.2812C8.86531 11.7198 8.93352 11.2987 9.06994 10.8777C9.20635 10.597 9.34277 10.3162 9.6156 9.96536C9.82023 9.75483 10.0931 9.40394 10.5705 9.05305C11.048 8.63199 11.3208 8.2811 11.4572 8.07057C11.5937 7.78986 11.6619 7.57932 11.6619 7.29861C11.6619 6.73719 11.4572 6.31613 11.048 5.89506C10.6387 5.474 10.1613 5.26346 9.5474 5.26346C9.00173 5.26346 8.52427 5.474 8.11502 5.82488C7.70577 6.17577 7.50114 6.73719 7.36472 7.50915L6.00055 7.36879C6.13697 6.31613 6.47801 5.54417 7.09189 4.98275C7.70577 4.42133 8.45606 4.14062 9.47919 4.14062C10.5023 4.14062 11.389 4.42133 12.0029 5.05293C12.6168 5.61435 12.9578 6.31613 12.9578 7.15826C12.9578 7.6495 12.8214 8.07057 12.6168 8.49163C12.4122 8.9127 11.9347 9.40394 11.3208 9.96536C10.9116 10.3864 10.6387 10.6671 10.5023 10.8075C10.3659 10.9478 10.2977 11.2286 10.2295 11.4391C10.1613 11.6496 10.1613 12.0707 10.0931 12.6321H8.86531V12.7023ZM8.7971 15.4392V13.8953H10.2977V15.4392H8.7971Z" fill="black" />
                </svg>
                <span class="rc-tooltip-text">The overall smoothness and condition of the diamond's surface. A well polished diamond produces crisp reflections and maximized light transmission.</span>
              </span>
            </p>
            <p>
              <strong>SYMMETRY:</strong> 
              ${diamond.symmetry || '-'}
              <span class="rc-tooltip-wrap">
                <svg class="info__icon" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                  <path d="M9.54922 1.40356C14.051 1.40356 17.7343 5.19317 17.7343 9.82492C17.7343 14.4567 14.051 18.2463 9.54922 18.2463C5.04745 18.2463 1.36417 14.4567 1.36417 9.82492C1.36417 5.19317 5.04745 1.40356 9.54922 1.40356ZM9.54922 0C4.29715 0 0 4.42121 0 9.82492C0 15.2286 4.29715 19.6498 9.54922 19.6498C14.8013 19.6498 19.0984 15.2286 19.0984 9.82492C19.0984 4.35104 14.8013 0 9.54922 0Z" fill="black" />
                  <path d="M8.86531 12.7023C8.86531 12.4918 8.86531 12.3514 8.86531 12.2812C8.86531 11.7198 8.93352 11.2987 9.06994 10.8777C9.20635 10.597 9.34277 10.3162 9.6156 9.96536C9.82023 9.75483 10.0931 9.40394 10.5705 9.05305C11.048 8.63199 11.3208 8.2811 11.4572 8.07057C11.5937 7.78986 11.6619 7.57932 11.6619 7.29861C11.6619 6.73719 11.4572 6.31613 11.048 5.89506C10.6387 5.474 10.1613 5.26346 9.5474 5.26346C9.00173 5.26346 8.52427 5.474 8.11502 5.82488C7.70577 6.17577 7.50114 6.73719 7.36472 7.50915L6.00055 7.36879C6.13697 6.31613 6.47801 5.54417 7.09189 4.98275C7.70577 4.42133 8.45606 4.14062 9.47919 4.14062C10.5023 4.14062 11.389 4.42133 12.0029 5.05293C12.6168 5.61435 12.9578 6.31613 12.9578 7.15826C12.9578 7.6495 12.8214 8.07057 12.6168 8.49163C12.4122 8.9127 11.9347 9.40394 11.3208 9.96536C10.9116 10.3864 10.6387 10.6671 10.5023 10.8075C10.3659 10.9478 10.2977 11.2286 10.2295 11.4391C10.1613 11.6496 10.1613 12.0707 10.0931 12.6321H8.86531V12.7023ZM8.7971 15.4392V13.8953H10.2977V15.4392H8.7971Z" fill="black" />
                </svg>
                <span class="rc-tooltip-text">The exactness of shape and alignment of individual facets. A diamond with excellent symmetry will have beautiful brilliance.</span>
              </span>
            </p>
            <p>
              <strong>FLUORESCENCE:</strong> 
              ${diamond.fluor_intensity || '-'}
              <span class="rc-tooltip-wrap">
                <svg class="info__icon" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                  <path d="M9.54922 1.40356C14.051 1.40356 17.7343 5.19317 17.7343 9.82492C17.7343 14.4567 14.051 18.2463 9.54922 18.2463C5.04745 18.2463 1.36417 14.4567 1.36417 9.82492C1.36417 5.19317 5.04745 1.40356 9.54922 1.40356ZM9.54922 0C4.29715 0 0 4.42121 0 9.82492C0 15.2286 4.29715 19.6498 9.54922 19.6498C14.8013 19.6498 19.0984 15.2286 19.0984 9.82492C19.0984 4.35104 14.8013 0 9.54922 0Z" fill="black" />
                  <path d="M8.86531 12.7023C8.86531 12.4918 8.86531 12.3514 8.86531 12.2812C8.86531 11.7198 8.93352 11.2987 9.06994 10.8777C9.20635 10.597 9.34277 10.3162 9.6156 9.96536C9.82023 9.75483 10.0931 9.40394 10.5705 9.05305C11.048 8.63199 11.3208 8.2811 11.4572 8.07057C11.5937 7.78986 11.6619 7.57932 11.6619 7.29861C11.6619 6.73719 11.4572 6.31613 11.048 5.89506C10.6387 5.474 10.1613 5.26346 9.5474 5.26346C9.00173 5.26346 8.52427 5.474 8.11502 5.82488C7.70577 6.17577 7.50114 6.73719 7.36472 7.50915L6.00055 7.36879C6.13697 6.31613 6.47801 5.54417 7.09189 4.98275C7.70577 4.42133 8.45606 4.14062 9.47919 4.14062C10.5023 4.14062 11.389 4.42133 12.0029 5.05293C12.6168 5.61435 12.9578 6.31613 12.9578 7.15826C12.9578 7.6495 12.8214 8.07057 12.6168 8.49163C12.4122 8.9127 11.9347 9.40394 11.3208 9.96536C10.9116 10.3864 10.6387 10.6671 10.5023 10.8075C10.3659 10.9478 10.2977 11.2286 10.2295 11.4391C10.1613 11.6496 10.1613 12.0707 10.0931 12.6321H8.86531V12.7023ZM8.7971 15.4392V13.8953H10.2977V15.4392H8.7971Z" fill="black" />
                </svg>
                <span class="rc-tooltip-text">A diamond's fluorescence grade refers to the intensity of the diamond's reaction to UV light (like black light). The GIA conducted a study which concluded that none to medium fluorescence has no negative impact on a diamond's appearance, which is why we only work with none-medium fluorescence grades. This study also found that some fluorescence can make IJK color diamonds appear whiter.</span>
              </span>
            </p>
            <div class="rc-bespoke-diamond-cta">
              <button 
                class="rc-bespoke-select-diamond-btn ${isSelected ? 'selected is-hide' : ''}" 
                data-cert="${diamond.cert_num}" 
                ${isSelected ? 'disabled' : ''}
              >SELECT THIS DIAMOND</button>
              <button 
                class="rc-bespoke-feed-review-design-cta ${isSelected ? '' : 'is-hide'}" 
                data-cert="${diamond.cert_num}"
                onclick="redirectToProductDetailPage()"
              >Review Your Design</button>
              <div class="rc-bespoke-secondary-cta">
                <button onclick="GorgiasChat.open()" class="rc-bespoke-chat-btn">CHAT WITH A SPECIALIST</button>
                <button class="rc-bespoke-share-btn" data-cert="${diamond.cert_num}"> SHARE DIAMOND </button>
              </div>
              <div class="rc-bespoke-diamond-remove-cta">
                <button 
                  class="rc-bespoke-remove-diamond-btn rc-button rc-button-underline ${isSelected ? '' : 'hidden'}"
                  data-cert="${diamond.cert_num}">REMOVE DIAMOND
                </button>
              </div>
            </div>
          </div>
          <div class="compare-diamond-wrapper">
            <div class="rc-compare-checkbox-text">
              <span class="selected-compare-checkbox-text">${isInCompare ? 'Added to compare' : 'Add to compare'}</span>
              <input type="checkbox" class="selected-compare-checkbox compare-checkbox" data-cert="${diamond.cert_num}" ${isInCompare ? 'checked' : ''}>
            </div>
            <div class="rc-compare-close-btn">
              <svg class="icon icon-close" width="28" height="28" viewBox="0 0 28 28" fill="none" aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg">
                <path d="M21 1L1 21M1 1L21 21" stroke="currentColor" stroke-linecap="square" stroke-linejoin="round"></path>
              </svg>
            </div>
          </div>
        </div>
      </div>
    `;
  }

  /* ========= Checkbox Handling of the Diamond ========= */
  $(document).on('click', '.selected-compare-checkbox, .compare-checkbox', function () {
    const certNum = $(this).data('cert');
    const isChecked = $(this).hasClass('compare-checkbox') ? $(this).is(':checked') : $('.compare-checkbox[data-cert="' + certNum + '"]').is(':checked');
    $('.selected-compare-checkbox[data-cert="' + certNum + '"], ' + '.compare-checkbox[data-cert="' + certNum + '"]').prop('checked', isChecked);
  });

  /* ========= FETCH DIAMOND FEED DATA ========= */
  function fetchData(page) {
    showLoader();

    const fluorPayload = getFluorescencePayloadBySteps(currentFluorStartStep, currentFluorEndStep);
    let payload = {
      page_number: page,
      page_size: PAGE_SIZE,
      price_total_from: currentPriceMin,
      price_total_to: currentPriceMax,
      size_from: currentCaratMin.toString(),
      size_to: currentCaratMax.toString(),
      color_from: currentColorFrom,
      color_to: currentColorTo,
      clarity_from: currentClarityFrom,
      clarity_to: currentClarityTo,
      ratio_min: currentRatioMin,
      ratio_max: currentRatioMax,
      ...fluorPayload,
      ...(isLabGrown ? { lg: true } : { lg: false }),
      ...(currentSortBy && currentSortDirection && {
        sort_by: currentSortBy,
        sort_direction: currentSortDirection
      }),
      ...(selectedCert && { diamondIdAtFirstPosition: selectedCert }), // sending selected cert number separately to the feed API :: diamondIdAtFirstPosition
      shapes: getSanitizedShapes()
    };

    if (!fluorPayload.fluor_intensity) {
      delete payload.fluor_intensity;
      delete payload.fluor_intensity_min;
      delete payload.fluor_intensity_max;
    }

    fetch(`${diamondFeedApiUrl}/diamonds/feedv3`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    })
    .then(res => res.json())
    .then(res => {
      if (!res?.response?.body) {
        hideLoader();
        $('#bespokeDiamondFeedData tbody').html(`
          <tr>
            <td colspan="9" class="rc-no-results">
              Something went wrong. Please try again.
            </td>
          </tr>
        `);
        return;
      }

      const body = res.response.body;
      const total = body.search_results.total_diamonds_found;
      let diamonds = body.diamonds;
      let selectedDiamond = null;

      if (selectedCert) {
        const idx = diamonds.findIndex(d => d.cert_num == selectedCert);
        if (idx !== -1) {
          selectedDiamond = diamonds.splice(idx, 1)[0];
        }
      }

      /* ========= Show Wrapper if "no diamond / less than 8" wrapper + diamonds count ========= */
      let totalVisibleDiamonds = diamonds.length + (selectedDiamond ? 1 : 0);
      if (totalVisibleDiamonds < 8) {
        $('.rc-no-diamond-available-wrapper').removeClass('hidden');
      } else {
        $('.rc-no-diamond-available-wrapper').addClass('hidden');
      }

      /* ========= No Diamond Available ========= */
      if (!diamonds.length && !selectedDiamond) {
        renderPagination(total, PAGE_SIZE, page);
        table.clear().draw();
        $('#bespokeDiamondFeedData').addClass('rc-table-ready');
        hideLoader();
        return;
      }

      table.clear();

      if (selectedDiamond) {
        table.row.add(mapRow(selectedDiamond));
      }

      diamonds.forEach(d => table.row.add(mapRow(d)));

      table.draw();
      $('#bespokeDiamondFeedData').addClass('rc-table-ready');
      hideLoader();
      renderPagination(total, PAGE_SIZE, page);
      updateSelectedCTA();

      /* ========= RESTORE COMPARE CHECKBOXES (column 8 — desktop only) ========= */
      $('.compare-checkbox').prop('checked', false).prop('disabled', false);
      $('.compare-checkbox').each(function () {
        const cert = String($(this).data('cert'));
        if (selectedCompareDiamonds.includes(cert)) {
          $(this).prop('checked', true);
        }
      });
      // Only disable unchecked ones if limit is reached
      if (selectedCompareDiamonds.length >= 3) {
        $('.compare-checkbox:not(:checked)').prop('disabled', true);
      }
      // Re-apply disable logic if 3 already selected
      if (selectedCompareDiamonds.length >= 3) {
        $('.compare-checkbox:not(:checked)').prop('disabled', true);
      }

      // Update Compare Diamonds CTA
      const selectedCount = selectedCompareDiamonds.length;
      $('.js-compare-btn').text(`COMPARE DIAMONDS (${selectedCount}/3)`).prop('disabled', selectedCount === 0);
      $('.js-reset-btn').prop('disabled', selectedCount === 0);

      if (selectedDiamond) {
        let firstRow = $('#bespokeDiamondFeedData tbody tr').first();
        let row = table.row(firstRow);
        row.child(showDiamondData(row.data())).show();
        firstRow.addClass('shown');
        firstRow.find('.accordion-icon').text('-');
        openRow = row;
        const cert = row.data().raw.cert_num;
        const el = document.getElementById(`panel__inner${cert}`);
        if (el) getDiamondVideo(el);

        /* ========= AUTO SCROLL TO OPENED ROW ========= */
        setTimeout(function () {
          if (window.matchMedia('(max-width: 767px)').matches) {
            window.scrollTo({ top: firstRow[0].offsetTop, behavior: 'smooth' });
          } else {
            firstRow[0].scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
        }, 500);

      } else if (selectedCert) {
        /* ========= CERT IN URL BUT NOT FOUND IN RESULTS ========= */
        $('#rc-generic-popup').find('.rc-popup-heading').text('This diamond is no longer available.');
        $('#rc-generic-popup').find('.rc-popup-subtext').text('Please browse our selection to find another diamond.');
        $('#rc-generic-popup').find('.rc-popup-cta').text('Browse More Diamonds').off('click').on('click', function() {
          const url = new URL(window.location.href);
          url.searchParams.delete('cert');
          window.location.href = url.toString();
        });
        $('#rc-generic-popup').addClass('open');
      }
    }).catch(err => {
      console.error("Diamond API Error:", err);
      hideLoader();

      $('#bespokeDiamondFeedData tbody').html(`
        <tr>
          <td colspan="9" class="rc-no-results">
            Unable to load diamonds. Please try again.
          </td>
        </tr>
      `);
    });
  }

  /* ========= BESPOKE DIAMOND FEED: TABLE ========= */
  let table = $('#bespokeDiamondFeedData').DataTable({
    paging: false,
    info: false,
    searching: false,
    ordering: false,
    language: {
      emptyTable: " ",
      zeroRecords: " "
    },
    drawCallback: function() {
      const api = this.api();
      if (api.data().count() === 0) {
        $('#bespokeDiamondFeedData tbody').html(`
          <tr>
            <td colspan="9" class="rc-no-results">
              There are currently no diamonds available in your selected criteria. Try adjusting your filters or check back later for more options!
            </td>
          </tr>
        `);
      }
    },
    columnDefs: [
      {
        targets: [7, 8],
        visible: window.innerWidth > 767
      }
    ],
    columns: [
      {
        data: 'shape',
        render: function (data, type, row) {
          const shape = data || '-';
          const svg = window.SHAPE_SVG_MAP?.[shape];
          if (!svg) return shape;
          return `
            <div class="rc-shape-cell">
              <span class="rc-shape-icon">${svg}</span>
              <span class="rc-shape-text">${shape}</span>
            </div>
          `;
        }
      },
      {
        data: 'size',
        render: d => {
          const num = Number(d);
          return Number.isFinite(num) ? `${num.toFixed(2)}ct` : '-';
        }
      },
      { data: 'color' },
      { data: 'clarity' },
      {
        data: null,
        render: function (data, type, row) {
          const d = row.raw;
          if (d.shape === "Round") {
            return d.cut || '-';
          }
          return 'Excellent';
        }
      },
      {
        data: 'certificate',
        orderable: false,
        render: function (data, type, row) {
          if (!row.raw.cert_num) return '-';
          const certUrl = getCertificateUrl(row.raw, isLabGrown);
          if (isLabGrown) {
            return `<a href="${certUrl}" target="_blank" class="rc-bespoke-view-cert-link">View <span>Certificate</span></a>`;
          }
          return `
            <a href="${certUrl}" target="_blank">
              <img class="rc-bespoke-gia-cert" src="https://rc-diamond-images.s3.us-east-2.amazonaws.com/Gemological.png" alt="GIA certificate" width="65px" height="20px">
            </a>`;
        }
      },
      {
        data: 'price',
        render: d => `$${Number(d).toLocaleString()}`
      },
      {
        data: null,
        orderable: false,
        render: function () {
          return `<span class="accordion-icon">${arrowDown}</span>`;
        }
      },
      {
        data: null,
        orderable: false,
        render: function (data, type, row) {
          return `<input type="checkbox" class="compare-checkbox" data-cert="${row.raw.cert_num}">`;
        }
      }
    ]
  });

  function toggleMobileColumns() {
    const isMobile = window.innerWidth <= 767;
    table.column(7).visible(!isMobile);
    table.column(8).visible(!isMobile);
    table.columns.adjust().draw(false);

    /* ========= RESTORE COMPARE CHECKBOXES AFTER COLUMN 8 RE-RENDERS ========= */
    if (!isMobile) {
      $('.compare-checkbox').each(function () {
        const cert = String($(this).data('cert'));
        if (selectedCompareDiamonds.includes(cert)) {
          $(this).prop('checked', true);
        }
      });
      if (selectedCompareDiamonds.length >= 3) {
        $('.compare-checkbox:not(:checked)').prop('disabled', true);
      }
    }
  }

  $(window).on('resize', function () {
    toggleMobileColumns();
  });

  toggleMobileColumns();

  /* ========= ON PAGINATION CLICK: SCROLL TO TOP OF THE TABLE ========= */
  $(document).on('click', '.rc-bespoke-page-btn', function () {
    currentPage = parseInt($(this).data('page'));
    selectedCert = null;
    updateURL();
    fetchData(currentPage);
    $('html, body').animate({
      scrollTop: $('#bespokeDiamondFeedData').offset().top - 120
    }, 400);
  });

  /* ========= TABLE: SORTING LOGIC ========= */
  $('#bespokeDiamondFeedData thead').on('click', 'th.sortable', function () {
    const index = $(this).index();

    const map = {
      0: 'shape',
      1: 'carat',
      2: 'color',
      3: 'clarity',
      6: 'price'
    };

    const key = map[index];
    if (!key) return;

    const apiKey = SORT_MAP[key];
    if (currentSortBy === apiKey) {
      currentSortDirection = currentSortDirection === 'Asc' ? 'Desc' : 'Asc';
    } else {
      currentSortBy = apiKey;
      currentSortDirection = 'Desc';
    }

    currentPage = 1;
    updateURL();
    fetchData(currentPage);
    updateSortUI($(this));
  });

  /* ========= Inject default sort arrows into all sortable headers ========= */
  $('#bespokeDiamondFeedData thead th.sortable').each(function () {
    $(this).find('span').append(arrowDown);
  });

  if (currentSortBy && currentSortDirection) {
    const reverseMap = {
      shapes: 0,
      Size: 1,
      color: 2,
      clarity: 3,
      Price: 6
    };
    const index = reverseMap[currentSortBy];
    const $th = $('#bespokeDiamondFeedData thead th').eq(index);
    updateSortUI($th);
  }

  function updateSortUI($th) {
    $('#bespokeDiamondFeedData thead th.sortable').each(function () {
      $(this).find('.sort-arrow').remove();
      $(this).removeClass('sort-asc sort-desc');
      $(this).find('span').append(arrowDown);
    });
    $th.find('.sort-arrow').remove();
    if (currentSortDirection === 'Asc') {
      $th.addClass('sort-asc').find('span').append(arrowDown);
    } else {
      $th.addClass('sort-desc').find('span').append(arrowUp);
    }
  }

  /* ========= SHAPE FILTER ========= */
  $('.shape-list input').on('change', function () {
    filters.shapes = [];
    $('.shape-list input:checked').each(function () {
      filters.shapes.push($(this).val());
    });
    currentPage = 1;
    selectedCert = null;
    updateURL();
    fetchData(currentPage);
  });

  /* ========= NATURAL/LAB GROWN TOGGLE ========= */
  $('.diamond-type-btn').on('click', function () {
    const type = $(this).data('type');
    $('.diamond-type-btn').removeClass('active');
    $(this).addClass('active');

    isLabGrown = type === 'lab';

    handleAntiqueShapesState();

    const currentRange = isLabGrown ? PRICE_RANGE.lab : PRICE_RANGE.natural;
    const prevRange    = isLabGrown ? PRICE_RANGE.natural : PRICE_RANGE.lab;
    const isStillDefault = isDefaultRange(currentPriceMin, currentPriceMax, prevRange);

    if (!isPriceInteracted || isStillDefault) {
      currentPriceMin = currentRange.min;
      currentPriceMax = currentRange.max;
    }

    const prevCaratMax = isLabGrown ? maxCaratNatural : maxCaratLabGrown;
    const isCaratDefault =
      currentCaratMin === (isLabGrown ? minCaratNatural : minCaratLabGrown) &&
      currentCaratMax === prevCaratMax;
    if (!isCaratInteracted || isCaratDefault) {
      currentCaratMin = isLabGrown ? minCaratLabGrown : minCaratNatural;
      currentCaratMax = isLabGrown ? maxCaratLabGrown : maxCaratNatural;
    }

    if (!isColorInteracted) {
      currentColorFrom = "D";
      currentColorTo = "J";
      if (colorSlider) {
        colorSlider.noUiSlider.set([0, COLOR_SCALE.length - 1]);
      }
    } else {
      if (colorSlider) {
        colorSlider.noUiSlider.set([
          COLOR_SCALE.indexOf(currentColorFrom),
          COLOR_SCALE.indexOf(currentColorTo)
        ]);
      }
    }

    if (!isClarityInteracted) {
      currentClarityFrom = "IF";
      currentClarityTo = "SI2";
      if (claritySlider) {
        claritySlider.noUiSlider.set([0, CLARITY_SCALE.length - 1]);
      }
    } else {
      if (claritySlider) {
        claritySlider.noUiSlider.set([
          CLARITY_SCALE.indexOf(currentClarityFrom),
          CLARITY_SCALE.indexOf(currentClarityTo)
        ]);
      }
    }

    if (!isFluorescenceInteracted) {
      currentFluorStartStep = 1;
      currentFluorEndStep = 4;
      if (fluorescenceSlider) {
        fluorescenceSlider.noUiSlider.set([0, 3]);
      }
    }

    if (priceSlider && priceSlider.noUiSlider) {
      const defaultMin = isLabGrown ? minPriceLabGrown : minPriceNatural;
      const defaultMax = isLabGrown ? maxPriceLabGrown : maxPriceNatural;
      let minPrice, maxPrice;

      if (isPriceInteracted) {
        minPrice = Math.max(defaultMin, Math.min(currentPriceMin, defaultMax));
        maxPrice = Math.max(defaultMin, Math.min(currentPriceMax, defaultMax));
        if (minPrice > maxPrice) {
          minPrice = defaultMin;
          maxPrice = defaultMax;
        }
      } else {
        minPrice = defaultMin;
        maxPrice = defaultMax;
      }

      priceSlider.noUiSlider.updateOptions({
        range: { min: defaultMin, max: defaultMax }
      });
      priceSlider.noUiSlider.set([minPrice, maxPrice]);
      currentPriceMin = minPrice;
      currentPriceMax = maxPrice;
      $('#priceMin').val('$' + minPrice.toLocaleString());
      $('#priceMax').val('$' + maxPrice.toLocaleString());
    }

    if (caratSlider && caratSlider.noUiSlider) {
      const defaultMin = isLabGrown ? minCaratLabGrown : minCaratNatural;
      const defaultMax = isLabGrown ? maxCaratLabGrown : maxCaratNatural;
      let minCarat, maxCarat;

      if (isCaratInteracted) {
        minCarat = Math.max(defaultMin, Math.min(currentCaratMin, defaultMax));
        maxCarat = Math.max(defaultMin, Math.min(currentCaratMax, defaultMax));
        if (minCarat >= maxCarat) {
          minCarat = defaultMin;
          maxCarat = defaultMax;
        }
      } else {
        minCarat = defaultMin;
        maxCarat = defaultMax;
      }

      caratSlider.noUiSlider.updateOptions({
        range: { min: defaultMin, max: defaultMax }
      });
      caratSlider.noUiSlider.set([minCarat, maxCarat]);
      currentCaratMin = minCarat;
      currentCaratMax = maxCarat;
      $('#caratMin').val(minCarat.toFixed(2));
      $('#caratMax').val(maxCarat.toFixed(2));
    }

    currentPage = 1;
    selectedCert = null;
    updateURL();
    fetchData(currentPage);
  });

  /* ========= ROW CLICK: SHOW DIAMOND DATA ========= */
  $('#bespokeDiamondFeedData tbody').on('click', 'tr', function (e) {
    if ($(e.target).closest('.accordion-content').length) return;
    if ($(e.target).closest('.rc-bespoke-select-diamond-btn').length) return;
    if ($(e.target).closest('a').length || $(e.target).is('input[type="checkbox"]')) return;
    if ($(this).hasClass('child')) return;

    let row = table.row(this);
    let data = row.data();

    if (!data) return;

    let cert = data.raw.cert_num;

    if (row.child.isShown()) {
      row.child.hide();
      $(this).removeClass('shown');
      $(this).find('.accordion-icon').html(arrowDown);
      openRow = null;
      selectedCert = null;
      updateURL();
      return;
    }

    if (openRow) {
      $(openRow.node()).find('.accordion-icon').html(arrowDown);
      openRow.child.hide();
      $(openRow.node()).removeClass('shown');
    }

    row.child(showDiamondData(data)).show();
    $(this).addClass('shown');
    $(this).find('.accordion-icon').html(arrowUp);
    openRow = row;
    selectedCert = cert;
    updateURL();

    const el = document.getElementById(`panel__inner${cert}`);
    if (el) {
      getDiamondVideo(el);
    }
  });

  /* ========= CLOSE ICON: HIDE DIAMOND DETAILS ========= */
  $(document).on('click', '.icon-close', function (e) {
    e.stopPropagation();
    if (openRow) {
      $(openRow.node()).find('.accordion-icon').html(arrowDown);
      openRow.child.hide();
      $(openRow.node()).removeClass('shown');
      openRow = null;
      selectedCert = null;
      updateURL();
    }
  });

  /* ========= FILTER SLIDERS ========= */
  let priceSlider = document.getElementById('priceSlider');
  let caratSlider = document.getElementById('caratSlider');
  let colorSlider = document.getElementById('colorSlider');
  let claritySlider = document.getElementById('claritySlider');
  let ratioSlider = document.getElementById('ratioSlider');
  let fluorescenceSlider = document.getElementById('fluorescenceSlider');

  const PRICE_RANGE = {
    natural: { min: minPriceNatural, max: maxPriceNatural },
    lab: { min: minPriceLabGrown, max: maxPriceLabGrown }
  };

  const CARAT_RANGE = {
    natural: { min: minCaratNatural, max: maxCaratNatural },
    lab: { min: minCaratLabGrown, max: maxCaratLabGrown }
  };

  const priceRange = isLabGrown ? PRICE_RANGE.lab : PRICE_RANGE.natural;
  const caratRange = isLabGrown ? CARAT_RANGE.lab : CARAT_RANGE.natural;

  currentPriceMin = clamp(currentPriceMin, priceRange.min, priceRange.max);
  currentPriceMax = clamp(currentPriceMax, priceRange.min, priceRange.max);
  currentCaratMin = clamp(currentCaratMin, caratRange.min, caratRange.max);
  currentCaratMax = clamp(currentCaratMax, caratRange.min, caratRange.max);
  currentRatioMin = clamp(currentRatioMin, minRatioDefault, maxRatioDefault);
  currentRatioMax = clamp(currentRatioMax, minRatioDefault, maxRatioDefault);

  /* ========= PRICE SLIDER ========= */
  if (priceSlider) {
    noUiSlider.create(priceSlider, {
      start: [
        currentPriceMin || priceRange.min,
        currentPriceMax || priceRange.max
      ],
      connect: true,
      step: 250,
      range: { min: priceRange.min, max: priceRange.max }
    });

    priceSlider.noUiSlider.on('update', function (values) {
      currentPriceMin = Math.round(values[0]);
      currentPriceMax = Math.round(values[1]);
      $('#priceMin').val('$' + currentPriceMin.toLocaleString());
      $('#priceMax').val('$' + currentPriceMax.toLocaleString());
    });

    priceSlider.noUiSlider.on('change', function () {
      isPriceInteracted = true;
      currentPage = 1;
      selectedCert = null;
      updateURL();
      fetchData(currentPage);
    });
  }

  /* ========= CARAT WEIGHT SLIDER ========= */
  if (caratSlider) {
    noUiSlider.create(caratSlider, {
      start: [
        currentCaratMin || caratRange.min,
        currentCaratMax || caratRange.max
      ],
      connect: true,
      step: 0.01,
      range: { min: caratRange.min, max: caratRange.max }
    });

    caratSlider.noUiSlider.on('update', function (values) {
      currentCaratMin = parseFloat(values[0]);
      currentCaratMax = parseFloat(values[1]);
      $('#caratMin').val(currentCaratMin.toFixed(2));
      $('#caratMax').val(currentCaratMax.toFixed(2));
    });

    caratSlider.noUiSlider.on('change', function () {
      isCaratInteracted = true;
      currentPage = 1;
      selectedCert = null;
      updateURL();
      fetchData(currentPage);
    });
  }

  /* ========= COLOR SLIDER ========= */
  if (colorSlider) {
    noUiSlider.create(colorSlider, {
      start: [
        COLOR_SCALE.indexOf(currentColorFrom),
        COLOR_SCALE.indexOf(currentColorTo)
      ],
      connect: true,
      step: 1,
      range: { min: 0, max: COLOR_SCALE.length - 1 }
    });

    colorSlider.noUiSlider.on('update', function (values) {
      currentColorFrom = COLOR_SCALE[Math.round(values[0])];
      currentColorTo = COLOR_SCALE[Math.round(values[1])];
    });

    colorSlider.noUiSlider.on('change', function () {
      isColorInteracted = true;
      currentPage = 1;
      selectedCert = null;
      updateURL();
      fetchData(currentPage);
    });
  }

  /* ========= CLARITY SLIDER ========= */
  if (claritySlider) {
    noUiSlider.create(claritySlider, {
      start: [
        CLARITY_SCALE.indexOf(currentClarityFrom),
        CLARITY_SCALE.indexOf(currentClarityTo)
      ],
      connect: true,
      step: 1,
      range: { min: 0, max: CLARITY_SCALE.length - 1 }
    });

    claritySlider.noUiSlider.on('update', function (values) {
      currentClarityFrom = CLARITY_SCALE[Math.round(values[0])];
      currentClarityTo = CLARITY_SCALE[Math.round(values[1])];
    });

    claritySlider.noUiSlider.on('change', function () {
      isClarityInteracted = true;
      currentPage = 1;
      selectedCert = null;
      updateURL();
      fetchData(currentPage);
    });
  }

  /* ========= FLUORESCENCE SLIDER ========= */
  if (fluorescenceSlider) {
    noUiSlider.create(fluorescenceSlider, {
      start: [
        currentFluorStartStep - 1,
        currentFluorEndStep - 1
      ],
      connect: true,
      step: 1,
      range: { min: 0, max: 3 }
    });

    fluorescenceSlider.noUiSlider.on('update', function (values) {
      currentFluorStartStep = Math.round(values[0]) + 1;
      currentFluorEndStep   = Math.round(values[1]) + 1;
    });

    fluorescenceSlider.noUiSlider.on('change', function () {
      isFluorescenceInteracted = true;
      currentPage = 1;
      selectedCert = null;
      updateURL();
      fetchData(currentPage);
    });
  }

  /* ========= RATIO SLIDER ========= */
  if (ratioSlider) {
    noUiSlider.create(ratioSlider, {
      start: [currentRatioMin, currentRatioMax],
      connect: true,
      step: 0.01,
      range: { min: minRatioDefault, max: maxRatioDefault }
    });

    ratioSlider.noUiSlider.on('update', function (values) {
      currentRatioMin = parseFloat(values[0]);
      currentRatioMax = parseFloat(values[1]);
      $('#ratioMin').val(currentRatioMin.toFixed(2));
      $('#ratioMax').val(currentRatioMax.toFixed(2));
    });

    ratioSlider.noUiSlider.on('change', function () {
      isRatioInteracted = true;
      currentPage = 1;
      selectedCert = null;
      updateURL();
      fetchData(currentPage);
    });
  }

  /* ========= INPUT → SLIDER + API SYNC ========= */
  $('#priceMin, #priceMax').on('change', function () {
    if (!priceSlider || !priceSlider.noUiSlider) return;
    let min = parseInt($('#priceMin').val().replace(/[$,]/g, '')) || priceRange.min;
    let max = parseInt($('#priceMax').val().replace(/[$,]/g, '')) || priceRange.max;
    if (min > max) min = max;
    priceSlider.noUiSlider.set([min, max]);
    currentPage = 1;
    selectedCert = null;
    isPriceInteracted = true;
    updateURL();
    fetchData(currentPage);
  });

  /* ========= CARAT INPUT → SLIDER SYNC ========= */
  $('#caratMin, #caratMax').on('change', function () {
    if (!caratSlider || !caratSlider.noUiSlider) return;
    let min = parseFloat($('#caratMin').val()) || caratRange.min;
    let max = parseFloat($('#caratMax').val()) || caratRange.max;
    if (min > max) min = max;
    caratSlider.noUiSlider.set([min, max]);
    currentPage = 1;
    selectedCert = null;
    isCaratInteracted = true;
    updateURL();
    fetchData(currentPage);
  });

  /* ========= RATIO INPUT → SLIDER ========= */
  $('#ratioMin, #ratioMax').on('change', function () {
    if (!ratioSlider || !ratioSlider.noUiSlider) return;
    let min = parseFloat($('#ratioMin').val()) || minRatioDefault;
    let max = parseFloat($('#ratioMax').val()) || maxRatioDefault;
    if (min > max) min = max;
    ratioSlider.noUiSlider.set([min, max]);
    isRatioInteracted = true;
    currentPage = 1;
    selectedCert = null;
    updateURL();
    fetchData(currentPage);
  });

  /* ========= COMPARE DIAMONDS: MAX-3 ========= */
  $(document).on('change', '.compare-checkbox', function () {
    const cert = String($(this).data('cert'));
    if ($(this).is(':checked')) {
      if (selectedCompareDiamonds.length >= 3) {
        $(this).prop('checked', false);
        return;
      }
      if (!selectedCompareDiamonds.includes(cert)) {
        selectedCompareDiamonds.push(cert);
      }
    } else {
      selectedCompareDiamonds = selectedCompareDiamonds.filter(c => c !== cert);
    }

    /* ========= SYNC LABEL TEXT FOR ALL CHECKBOXES WITH THIS CERT ========= */
    const isNowChecked = selectedCompareDiamonds.includes(cert);
    $(`.compare-checkbox[data-cert="${cert}"]`).closest('.rc-bespoke-diamond-wrapper')
      .find('.selected-compare-checkbox-text')
      .text(isNowChecked ? 'Added to compare' : 'Add to compare');

    if (selectedCompareDiamonds.length >= 3) {
      $('.compare-checkbox:not(:checked)').prop('disabled', true);
    } else {
      $('.compare-checkbox').prop('disabled', false);
    }

    const selectedCount = selectedCompareDiamonds.length;
    $('.js-compare-btn').text(`Compare Diamonds (${selectedCount}/3)`).prop('disabled', selectedCount === 0);
    $('.js-reset-btn').prop('disabled', selectedCount === 0);

    updateCompareInURL();
  });

  /* ========= RESET COMPARE ========= */
  $(document).on('click', '.js-reset-btn', function () {
    selectedCompareDiamonds = [];
    $('.compare-checkbox').prop('checked', false);
    $('.compare-checkbox').prop('disabled', false);
    $('.js-compare-btn').text('COMPARE DIAMONDS (0/3)').prop('disabled', true);
    $('.js-reset-btn').prop('disabled', true);
    updateCompareInURL();
  });

  /* ========= COMPARE CTA REDIRECT ========= */
  $(document).on('click', '.js-compare-btn', function () {
    if (selectedCompareDiamonds.length === 0) return;
    const currentParams = window.location.search;
    window.location.href = `/pages/diamond-compare${currentParams}`;
  });

  /* ========= SELECT THIS DIAMOND: CTA ACTION ========= */
  $(document).on('click', '.rc-bespoke-select-diamond-btn', function (e) {
    e.preventDefault();
    e.stopImmediatePropagation();
    const cert = $(this).data('cert');
    if (!cert) return;

    let selectedDiamondData = null;
    table.rows().every(function () {
      const rowData = this.data();
      if (rowData?.raw?.cert_num == cert) {
        selectedDiamondData = rowData.raw;
      }
    });
    if (!selectedDiamondData) return;

    saveSelectedDiamond(selectedDiamondData);
    selectedCert = cert;
    updateURL();
    updateSelectedCTA();
  });

  /* ========= UPDATE SELECTED CTA TEXT ========= */
  function updateSelectedCTA() {
    const selectedDiamond = getSelectedDiamondFromStorage();
    $('.rc-bespoke-select-diamond-btn').each(function () {
      const btnCert = $(this).data('cert');
      const isSelected = selectedDiamond && selectedDiamond.cert_num == btnCert;
      if (isSelected) {
        //$(this).text('SELECTED').addClass('selected').prop('disabled', true);
        $(this).addClass('selected').prop('disabled', true);
        $(this).siblings('.rc-bespoke-remove-diamond-btn').removeClass('hidden');
      } else {
        $(this).text('SELECT THIS DIAMOND').removeClass('selected').prop('disabled', false);
        $(this).siblings('.rc-bespoke-remove-diamond-btn').addClass('hidden');
      }
    });
  }

  /* ========= REMOVE SELECTED DIAMOND ========= */
  $(document).on('click', '.rc-bespoke-remove-diamond-btn', function (e) {
    e.preventDefault();
    e.stopImmediatePropagation();
    
    const cert = $(this).data('cert');
    localStorage.removeItem('rc_selected_diamond');
    localStorage.removeItem('selected-diamond-shopify-data');
    // Hide remove button
    $(this).addClass('hidden');
    // Swap CTAs
    $(`.rc-bespoke-feed-review-design-cta[data-cert="${cert}"]`).addClass('is-hide');
    $(`.rc-bespoke-select-diamond-btn[data-cert="${cert}"]`).removeClass('is-hide selected').prop('disabled', false).text('SELECT THIS DIAMOND');
    updateSelectedCTA();
  });

  /* ========= INITIALIZATION ========= */
  fetchData(currentPage);

  /* ========= FILTERS ACCORDION CONTROL ========= */
  const triggers = document.querySelectorAll('.rc-acordian-trigger');
  triggers.forEach((trigger) => {
    trigger.addEventListener('click', () => {
      const filterGroup = trigger.closest('.filter-group');
      const content = filterGroup.querySelector('.rc-popover-content');
      document.querySelectorAll('.rc-popover-content').forEach((item) => {
        if (item !== content) {
          item.classList.remove('active');
        }
      });
      content.classList.toggle('active');
    });
  });

  document.addEventListener('click', (event) => {
    if (!event.target.closest('.filter-group')) {
      document.querySelectorAll('.rc-popover-content').forEach((item) => {
        item.classList.remove('active');
      });
    }
  });

  /* ========= ADDITIONAL FILTERS: CONTROL ========= */
  const additionalFilterBtn = document.querySelector('.rc-additional-filter-btn');
  const additionalFilters = document.querySelector('.rc-bespoke-bottom-filters');
  if (additionalFilterBtn && additionalFilters) {
    additionalFilterBtn.addEventListener('click', () => {
      additionalFilters.classList.toggle('active');
      additionalFilterBtn.classList.toggle('active');
    });
  }
});

document.querySelectorAll('.rc-filter-btn').forEach((btn) => {
  btn.addEventListener('click', () => {
    document
      .querySelectorAll('.rc-bespoke-filter-toggle, .rc-bespoke-filter-mobile')
      .forEach((el) => {
        el.classList.toggle('active');
      });
  });
});